import { render, staticRenderFns } from "./SvgPlus.vue?vue&type=template&id=5e04c8b6&scoped=true&"
import script from "./SvgPlus.vue?vue&type=script&lang=js&"
export * from "./SvgPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e04c8b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e04c8b6')) {
      api.createRecord('5e04c8b6', component.options)
    } else {
      api.reload('5e04c8b6', component.options)
    }
    module.hot.accept("./SvgPlus.vue?vue&type=template&id=5e04c8b6&scoped=true&", function () {
      api.rerender('5e04c8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Offers/SvgPlus.vue"
export default component.exports